import React, { useEffect, useRef } from "react";
import { CountUp } from "countup.js";
import _ from "lodash";

const Counter = ({ end, duration = 2, decimals = 0, prefix = "", suffix = "", className = "" }) => {
  const counterRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    // Callback when the element is visible
    const callback = (entries) => {
      _.forEach(entries, (entry) => {
        if (entry.isIntersecting) {
          const countUp = new CountUp(counterRef.current, end, {
            duration,
            decimalPlaces: decimals,
            prefix,
            suffix,
          });

          if (!countUp.error) {
            countUp.start();
          } else {
            console.error(countUp.error);
          }

          // Stop observing after first count
          if (observerRef.current) {
            observerRef.current.disconnect();
          }
        }
      });
    };

    // Create IntersectionObserver
    observerRef.current = new IntersectionObserver(callback, {
      threshold: 0.3, // Trigger when 30% visible
    });

    if (counterRef.current) {
      observerRef.current.observe(counterRef.current);
    }

    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [end, duration, decimals, prefix, suffix]);

  return <h2 ref={counterRef} className={className}></h2>;
};

export default React.memo(Counter);
